import {
  PaginatedArray,
  VoiceboxPanelData,
} from 'bones/constants/voicebox/panel';
import { asyncNoop } from 'bones/utils/noop';

export const getDefaultPaginatedArray = <T>(): PaginatedArray<T> => ({
  items: [],
  count: 0,
  loading: false,

  hasMore: false,
  loadingMore: false,
  loadMore: asyncNoop,
});

export const DEFAULT_VOICEBOX_PANEL_DATA: VoiceboxPanelData = {
  loaded: { body: false, label: false },
  attributes: { attributes: [], loading: false },
  relationships: { relationships: [], loading: false },
  instances: getDefaultPaginatedArray(),
  types: { types: [], loading: false },
};
